import type { IncidentsBlock } from "@/lib/dashboardApi";
import { OperatorPanel } from "@/components/admin/dashboard/OperatorPanel";

export function IncidentsTable({
  data,
}: {
  data: IncidentsBlock;
}): JSX.Element {
  return (
    <OperatorPanel
      testId="platform-health-incidents"
      kicker="Incidents"
      title="Tenant-impacting incidents"
      headerRight={
        data.status !== "ok" ? (
          <span
            data-testid="badge-unavailable-incidents"
            className="rounded bg-surface-canvas px-2 py-0.5 text-2xs text-text-tertiary"
          >
            Unavailable
          </span>
        ) : undefined
      }
    >
      {data.incidents.length === 0 ? (
        <p className="text-sm text-text-secondary">No incidents.</p>
      ) : (
        <ul className="text-sm text-text-primary">
          {data.incidents.map((i, idx) => (
            <li key={idx}>{JSON.stringify(i)}</li>
          ))}
        </ul>
      )}
    </OperatorPanel>
  );
}
